import CronSerializer from './base';

export default class ProcessMonitor extends CronSerializer {}
